// src/pages/DomicilioPage.js
import React from 'react';
import { MessageSquare, MapPin, CreditCard, Clock, CheckCircle } from 'lucide-react';
import './DomicilioPage.css';

const DomicilioPage = () => {
  const whatsappNumber = '573001234567'; // ¡REEMPLAZA CON EL NÚMERO REAL!
  const message = encodeURIComponent('¡Hola! Quisiera hacer un pedido.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <div className="domicilio-page">
      <div className="container">
        <h1 className="domicilio-title">Programa tu Domicilio</h1>
        <p className="domicilio-subtitle">
          Sigue estos sencillos pasos para recibir nuestros productos en la puerta de tu casa o negocio.
          <br/>Recuerda que los pedidos se programan de un día para otro.
        </p>

        <section className="steps-section">
          <div className="step-card">
            <div className="step-icon-container">
              <MessageSquare size={40} className="step-icon" />
              <h3>Envía tu Pedido por WhatsApp</h3>
            </div>
            <p>Selecciona los productos del catálogo, añádelos al carrito y envíanos tu pedido por WhatsApp. Nos encargaremos de confirmar tu domicilio y la forma de pago.</p>
            <a href={whatsappUrl} className="whatsapp-button" target="_blank" rel="noopener noreferrer">
              ¡Pide por WhatsApp Aquí!
            </a>
          </div>
        </section>

        <section className="info-section">
          <div className="info-card">
            <MapPin size={32} />
            <h4>Condiciones del Envío</h4>
            <p><strong>Pedido Mínimo:</strong> $55,000</p>
          </div>

          <div className="info-card">
            <CreditCard size={32} />
            <h4>Formas de Pago</h4>
            <p>Efectivo contra entrega</p>
            <p>Transferencia (Bancolombia)</p>
          </div>

          <div className="info-card">
            <Clock size={32} />
            <h4>Horarios de Atención</h4>
            <p><strong>Lunes a Viernes:</strong> 6:00 AM - 1:00 PM</p>
            <p><strong>Sábados:</strong> 6:00 AM - 12:00 PM</p>
            <p><em>No laboramos Domingos ni Festivos.</em></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default DomicilioPage;